<template>
  <div class="autosize">
    <textarea class="textarea" ref="textarea" @input="input" v-model="content" :placeholder="placeholder"></textarea>
    <div class="counter" v-if="counter">{{content.length}}/{{max}}</div>
  </div>
</template>
<script type="text/ecmascript-6">
import autosize from 'autosize'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 200
    },
    counter: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    tooLongAlert: {
      type: String,
      default: '文字过多'
    }
  },
  data() {
    return {
      content: ''
    }
  },
  created() {
  },
  mounted() {
    autosize(this.$refs.textarea)
  },
  methods: {
    input() {
      if (this.counter && (this.content.length > this.max)) {
        this.content = this.content.substring(0, this.max)
        this.$toast(this.tooLongAlert)
      }
      this.$emit('input', this.content)
    }
  },
  watch: {
    value(nv) {
      this.content = nv
    }
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .autosize{
    background-color: #fff;
    font-size: size(30);
    padding: size(20) size(30);
    .textarea{
      font-size: size(30);
      line-height: 1.3;
      padding: 0;
      background-color: transparent;
      color: inherit;
      min-height: size(200);
      &::placeholder{
        color: #CCCCCC;
      }
    }
    .counter{
      text-align: right;
      font-size: size(24);
      color: #999999;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/textarea.vue